"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTether = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var tether_1 = (0, tslib_1.__importDefault)(require("tether"));
function useTether(options) {
    var attachment = options.attachment, _a = options.targetAttachment, targetAttachment = _a === void 0 ? attachment : _a, _b = options.offset, offset = _b === void 0 ? '0 0' : _b, _c = options.targetOffset, targetOffset = _c === void 0 ? '0 0' : _c, targetModifier = options.targetModifier, constraints = options.constraints;
    var elementRef = (0, react_1.useRef)();
    var targetRef = (0, react_1.useRef)();
    var tether = typeof document === 'undefined' || !elementRef.current || !targetRef.current
        ? undefined
        : new tether_1.default({
            element: elementRef.current,
            target: targetRef.current,
            attachment: attachment,
            targetAttachment: targetAttachment,
            offset: offset,
            targetOffset: targetOffset,
            targetModifier: targetModifier,
            constraints: constraints,
        });
    function reposition() {
        if (tether)
            tether.position();
    }
    function destroy() {
        if (tether)
            tether.destroy();
    }
    (0, react_1.useEffect)(function () {
        if (typeof document === 'undefined')
            return undefined;
        if (!elementRef.current || !targetRef.current)
            return undefined;
        tether = new tether_1.default({
            element: elementRef.current,
            target: targetRef.current,
            attachment: attachment,
            targetAttachment: targetAttachment,
            offset: offset,
            targetOffset: targetOffset,
            targetModifier: targetModifier,
            constraints: constraints,
        });
        reposition();
        window.addEventListener('resize', reposition);
        document.body.addEventListener('resize', reposition);
        return function () {
            window.removeEventListener('resize', reposition);
            destroy();
        };
    }, [
        elementRef.current,
        targetRef.current,
        attachment,
        targetAttachment,
        offset,
        targetOffset,
        targetModifier,
        constraints,
    ]);
    return { elementRef: elementRef, targetRef: targetRef };
}
exports.useTether = useTether;
//# sourceMappingURL=tether.js.map